export class RemoteScreenService {
  constructor (api) {
    this.api = api
  }

    triggerCommand = ({ deviceId, cmdStr }) => this.api.post(`/devices/${deviceId}/device-rv-commands?command=${cmdStr}`)
}
